/**
 * Admin-role predicates.
 *
 * There is no account tier. A user is a row with a set of assigned roles, and
 * an empty set means they administer nothing — which is most people. These
 * take the roles array from `/api/me`, resolved server-side from
 * `UserAdminRole`.
 *
 * The old hierarchy comment lived here for a reason worth keeping: a strict
 * `=== 'TENANT_ADMIN'` once locked super admins out of the portal. Membership
 * checks below accept either, deliberately.
 */

/** Platform-level surfaces: the scope catalog, paid modules. Everything
 * tenant-level gates on permissions instead (lib/permissions.ts). */
export const isSuperAdmin = (roles: string[] | undefined): boolean =>
  (roles ?? []).includes('SUPER_ADMIN');
